function handleDouble(num) {
  !num && (num = 0);
  return num > 9 ? num : '0' + num;
}
function interval(dur, f, ms) {
  if (!dur || dur <= 0) {
    return ['00', '00', '00', '00'];
  }
  const d = Math.floor(dur / (1000 * 60 * 60 * 24)),    // 计算天数
    h = Math.floor(dur / (1000 * 60 * 60) % 24),        // 计算小时数
    m = Math.floor(dur / (1000 * 60) % 60),             // 计算分钟数
    s = Math.floor(dur / 1000 % 60);                    // 计算秒数

  let result = [handleDouble(d), handleDouble(h), handleDouble(m), handleDouble(s)];
  if (f && typeof f == 'object' && f.length) {
    if (f[0] && f[0] === 'h') {
      result = [handleDouble(d * 24 + h), handleDouble(m), handleDouble(s)];
    }
    if (f[0] && f[0] === 'm') {
      result = [handleDouble(d * 1440 + h * 60 + m), handleDouble(s)];
    }
    if (f.includes('ms')) {
      result.push(handleDouble(ms));
    }
  }
  return result;
}
export function Counter() {
  let that = this,
    d = 0,         // 按时间段倒计时
    f = null,         // 返回的时间格式
    begin = true,       // 是否开始
    timer = null,       // 计时器
    ms = 10,
    dates = ['00', '00', '00', '00'],
    timingCallback = null,
    stopCallback = null;

  function countFor() {
    that.clearCounter();
    dates = interval(d, f);
    timingCallback && timingCallback(dates);
    if (!begin || !d || d < 0) {
      stopCallback && stopCallback(dates);
      return;
    }
    d -= 1000;
    timer = setTimeout(() => {
      countFor();
    }, 1000);
  }
  // 毫秒倒计时
  function countMs() {
    that.clearCounter();
    dates = interval(d, f, ms);
    timingCallback && timingCallback(dates);
    if (!begin || !d || d < 0) {
      stopCallback && stopCallback(dates);
      return;
    }
    ms--;
    if (ms <= 0) {
      ms = 10;
      d -= 1000;
    }
    timer = setTimeout(() => {
      countMs();
    }, 100);
  }
  // 清除计时器
  this.clearCounter = () => {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  };
  // 暂停计时
  this.countStop = () => {
    begin = false;
    this.clearCounter();
  };
  // 开始计时
  this.countBegin = ({ during, format }, timingEvent, stopEvent) => {
    d = during;
    format && (f = format);
    begin = true;
    if (format && format.includes('ms')) {
      countMs();
    } else {
      countFor();
    }
    timingEvent && (timingCallback = timingEvent);
    stopEvent && (stopCallback = stopEvent);
  };
}